export default __webpack_public_path__ + "static/media/img-0357-central-african-full-face.829f7815.png";